import moment from "moment";

export const PAGE_TITLE = "Lead Feedback Types";
export const PAGE_SINGLE_TITLE = "Lead Feedback Type";
export const LINK_URL = "leadfeedbacktypes";
export const SEARCH_TERMS = ["name"];
export const inputFields = {
  name: {
    type: "string",
    required: true,
    title: "Name",
    inputType: "text",
  },
};
export const initialValues = {
  name: "",
};

export const view_all_table = [{ name: "Name", value: "name" }];
